// src/hooks/products/useForceDeleteProduct.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteProduct } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useForceDeleteProduct = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteProductMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteProduct,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete product");
        },
    });

    return {
        forceDeleteProduct: forceDeleteProductMutate,
        isForceDelete: isPending || isLoading,
    };
};

export default useForceDeleteProduct;
